import React from "react";
import {
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { enGB, th } from "date-fns/locale";

const LOCALES = { en: enGB, th };

const BRAND_BLUE = "#1560D4";

const calendarSx = {
  "& .MuiPickersDay-root:hover": { bgcolor: "#E8F0FA" },
  "& .MuiPickersDay-root.Mui-selected, & .PrivatePickersYear-yearButton.Mui-selected":
    {
      bgcolor: BRAND_BLUE,
      color: "#fff",
      "&:hover, &:focus": { bgcolor: BRAND_BLUE },
    },
  "& .MuiPickersDay-today:not(.Mui-selected)": {
    borderColor: BRAND_BLUE,
    color: BRAND_BLUE,
  },
};

const toggleButtonSx = {
  px: "12px",
  py: "2px",
  "&.Mui-selected, &.Mui-selected:hover": {
    bgcolor: BRAND_BLUE,
    color: "#fff",
  },
};

// Rendered as the calendar's action bar, so the toggle sits inside the popup
const CalendarLanguageToggle = ({ language, onLanguageChange }) => (
  <Stack direction="row" justifyContent="flex-end" sx={{ px: "16px", pb: "12px" }}>
    <ToggleButtonGroup
      size="small"
      exclusive
      value={language}
      onChange={(_, value) => value && onLanguageChange(value)}
    >
      <ToggleButton value="en" sx={toggleButtonSx}>
        EN
      </ToggleButton>
      <ToggleButton value="th" sx={toggleButtonSx}>
        TH
      </ToggleButton>
    </ToggleButtonGroup>
  </Stack>
);

export const FtiDatePicker = ({
  label,
  value,
  onChange,
  minDate,
  maxDate,
  sx,
}) => {
  const [language, setLanguage] = React.useState("en");

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={LOCALES[language]}
    >
      <DesktopDatePicker
        label={label}
        value={value}
        onChange={onChange}
        inputFormat="dd/MM/yyyy"
        minDate={minDate}
        maxDate={maxDate}
        disableFuture
        // The default keeps only the first letter, which repeats in Thai (อา. / อ.)
        dayOfWeekFormatter={(day) => day}
        PaperProps={{ sx: calendarSx }}
        components={{ ActionBar: CalendarLanguageToggle }}
        componentsProps={{
          actionBar: { language, onLanguageChange: setLanguage },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            sx={sx}
          />
        )}
      />
    </LocalizationProvider>
  );
};
